import { observable } from "mobx";
import OswebService from "../../../services/OswebService";
import moment from "moment";
import { montarSelectOption } from "../../../utils/formatar";

export default class OswebCadastrarStore {

    @observable solicitanteSelecionado;
    @observable tipoSelecionado;
    @observable servicoSelecionado;
    @observable motivoSelecionado;

    @observable novaOsweb;

    @observable servico
    @observable dadoContainer
    @observable dadoDocumento
    @observable valorContainer
    @observable valorDocumento

    @observable atualizar

    @observable servicos
    @observable motivos
    @observable mostrarProtocolo

    @observable salvando;

    @observable mensagemContainerOuDocumento;
    @observable loadingContainerDocumentos;
    @observable containers;
    @observable documentos;

    @observable atualizaDados;
    @observable radioItens;

    constructor() {
        this.navioSelecionado = false;

        this.solicitanteSelecionado;
        this.tipoSelecionado;
        this.servicoSelecionado;
        this.motivoSelecionado;

        this.novaOsweb = {
            SolicitanteId: 0,
            Tipo: "",
            EhCodContainer: false,
            Documento: "",
            ContainerSelecionado: "",
            DocumentoSelecionado: "",
            CdAgrupadorServico: "",
            MotivoId: 0,
            Protocolo: "",
            DataSugerida: null,
            Obs: ""
        };

        this.servico = ""
        this.dadoContainer = ""
        this.dadoDocumento = ""
        this.valorContainer = ""
        this.valorDocumento = ""

        this.atualizar = true;

        this.servicos = []
        this.motivos = []

        this.mostrarProtocolo = false

        this.salvando = false;

        this.mensagemContainerOuDocumento = "";
        this.loadingContainerDocumentos = false;
        this.containers = [];
        this.documentos = [];
        this.atualizaDados = true;

        // Controles do Radiobutton
        this.bloqueadoDoc = false;
        this.checkDoc = true;
        this.bloqueadoCntr = false;
        this.checkCntr = false;
        this.radioItens = [{ id: "doc", value: "doc", label: "Nº documento", checked: this.checkDoc, bloqueado: this.bloqueadoDoc },
        { id: "cntr", value: "cntr", label: "Cod. Container", checked: this.checkCntr, bloqueado: this.bloqueadoCntr }];

        this.service = new OswebService();
    }

    filtrarServicosPorTipoContainer = async (containerNbr) => {
        if (!!containerNbr) {
          console;
          const containersService = new ContainersService();
          const { data } = await containersService.detalhar(containerNbr);
          if (data) {
            const orderedContainers = data.sort((a, b) =>
              a.container.UnitId < b.container.UnitId ? 1 : -1
            );
            const [unitDetalhe] = orderedContainers;
            const { container } = unitDetalhe;
            if (container.Refrigerado === "V" && container.Category === "EXPRT") {
              this.servicos = this.servicos.filter(
                (servico) => servico.value !== "OW007"
              );
            }
          }
        }
      };

    setSolicitante = (event) => {
        if (event)
            this.solicitanteSelecionado = event;
        else
            this.solicitanteSelecionado = false;

        this.novaOsweb.SolicitanteId = this.solicitanteSelecionado ? this.solicitanteSelecionado.value : ""
    };

    setTipo = (event) => {
        this.servicos = [];
        this.servicoSelecionado = null;
        this.dadoContainer = null;
        this.dadoDocumento = null;
        if (event) {
            this.tipoSelecionado = event;
            //this.listarServicos();
            this.atualizaRadioItens(this.tipoSelecionado.value);
        } else {
            this.tipoSelecionado = null;
            this.novaOsweb.CdAgrupadorServico = ""
            if (this.motivos) {
                this.motivos = []
                this.motivoSelecionado = null
                this.novaOsweb.MotivoId = ""
            }
            /**Tenho que limpar e bloquear serviços */
        }

        this.novaOsweb.Tipo = this.tipoSelecionado ? this.tipoSelecionado.value : ""

        this.listarContainersDocumentos();

        this.atualizar = false;
        setTimeout(() => {
            this.atualizar = true;
        }, 1);
    };

    setServico = (event) => {
        this.atualizaDados = false;
        if (event) {
            this.servicoSelecionado = event;
            this.listarMotivos()
        }
        else {
            this.servicoSelecionado = null;
            this.motivos = []
            this.motivoSelecionado = null
            this.novaOsweb.MotivoId = ""
            /**Tenho que limpar e bloquear serviços */
        }

        this.novaOsweb.CdAgrupadorServico = this.servicoSelecionado ? this.servicoSelecionado.value : "";
        this.atualizaDados = true;
    };

    setMotivo = (event) => {
        if (event) {
            this.motivoSelecionado = event
        } else {
            this.motivoSelecionado = null
        }

        if (this.motivoSelecionado && this.motivoSelecionado.label === "MAPA") {
            this.mostrarProtocolo = true
        } else {
            this.novaOsweb.Protocolo = ""
            this.mostrarProtocolo = false
        }

        this.novaOsweb.MotivoId = this.motivoSelecionado ? this.motivoSelecionado.value : ""
    }

    setDadosDataSugerida = (event) => {
        if (event)
            this.novaOsweb.DataSugerida = event;
        else
            this.novaOsweb.DataSugerida = null;
    };

    setDocumentoContainerRadio = (event) => {
        if (event.target.value === "cntr") {
            this.checkCntr = true;
            this.bloqueadoCntr = false;
            this.checkDoc = false;
            this.novaOsweb.EhCodContainer = true
        }
        else if (event.target.value === "doc") {
            this.checkDoc = true;
            this.bloqueadoDoc = false;
            this.checkCntr = false;
            this.novaOsweb.EhCodContainer = false;
        }

        this.atualizaRadioItens();
        this.dadoContainer = null;
        this.dadoDocumento = null;
        this.limparDadosContainersDocumentos();
    }

    atualizaRadioItens(tipo = "") {
        if (tipo === "J") {
            this.checkDoc = true;
            this.bloqueadoDoc = false;
            this.checkCntr = false;
            this.bloqueadoCntr = true;
            this.novaOsweb.EhCodContainer = false;
        }
        if (tipo === "E") {
            this.checkCntr = true;
            this.bloqueadoCntr = false;
            this.checkDoc = false;
            this.bloqueadoDoc = true;
            this.novaOsweb.EhCodContainer = true;
        }
        if (tipo === "I") {
            this.bloqueadoCntr = false;
            this.bloqueadoDoc = false;
            this.novaOsweb.EhCodContainer = this.checkCntr;
        }
        this.radioItens = [{ id: "doc", value: "doc", label: "Nº documento", checked: this.checkDoc, bloqueado: this.bloqueadoDoc },
        { id: "cntr", value: "cntr", label: "Cod. Container", checked: this.checkCntr, bloqueado: this.bloqueadoCntr }];
    }

    setDocumentoContainer = (event) => {
        this.novaOsweb.Documento = event.target.value.toUpperCase()
    }

    setDocumento = (value) => {
        this.dadoDocumento = value ? value.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '') : false;
    }

    setContainer = (value) => {
        this.dadoContainer = value !== null ? value : false;
    }

    setDocumentoSelect = (value) => {
        this.valorDocumento = value !== null ? value : false;
    }

    setContainerSelect = (value) => {
        this.valorContainer = value !== null ? value : false;
    }

    /**Serviços para obter dados dos campos de select */

    listarServicos = async () => {
        try {
            this.servicos = [];
            const response = await this.service.listarServicos(this.tipoSelecionado.value);
            if (response && response.data) {
                response.data.map(servico => {
                    this.servicos.push({ label: servico.DscAgrupador, value: servico.CdAgrupador })
                });
            }
            if (this.servicos.length === 1) {
                let dado = {
                    label: this.servicos[0].label,
                    value: this.servicos[0].value
                }
                this.setServico(dado);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    listarMotivos = async () => {
        try {
            this.motivos = [];
            const response = await this.service.listarMotivos(this.servicoSelecionado.value);
            if (response && response.data) {
                response.data.map(motivo => {
                    this.motivos.push({ label: motivo.Motivo, value: motivo.Id })
                })
            }
            if (this.motivos.length === 1) {
                let dado = {
                    label: this.motivos[0].label,
                    value: this.motivos[0].value
                }
                this.setMotivo(dado);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    listarContainersDocumentos = () => {
        //Sempre tente lembrar de limpar dados que são volúveis
        //No caso eu posso ter ou não uma lista de containers ou uma mensagem de erro
        this.documentos = []
        this.containers = []
        this.mensagemContainerOuDocumento = ""

        const tipo = this.tipoSelecionado;
        const ehCodContainer = this.novaOsweb.EhCodContainer;
        const doc = ehCodContainer ? this.dadoContainer : this.dadoDocumento;

        // Para importação
        if (!tipo || (tipo.value !== "I" && tipo.value !== "J") || ehCodContainer === 'undefined' || !doc)
            return

        //Removido temporariamente para que em casos de importação de carga, a rotina valide a existência do BL
        //if (tipo.value === "J")
        //return

        this.loadingContainerDocumentos = true

        this.service.listarContainersOuDocumentos(tipo.value, ehCodContainer, doc).then(response => {
            if (!response || !response.data) return;

            if (!response.data.Sucesso) {
                this.mensagemContainerOuDocumento = response.data.Mensagem;
                return;
            }

            this.limparDadosContainersDocumentos();
            if (['I', 'E'].includes(tipo.value)) {
                if (ehCodContainer)
                    this.documentos = montarSelectOption("Doc", "Doc", response.data.ListDocumentos);
                else
                    this.containers = montarSelectOption("CodCntr", "CodCntr", response.data.ListContainers);
            }

        }).catch(err => {
            console.log("listarContainersOuDocumentos: ", err)
            this.mensagemContainerOuDocumento = `Houve um problema ao obter o ${this.tituloDocumentoContainer()}`
        }).finally(() => this.loadingContainerDocumentos = false)
    }

    tituloDocumentoContainer = () => (
        this.novaOsweb.EhCodContainer ? "Container" : "Documento"
    )

    tamanhoInputDocumentoContainer = () => (
        this.novaOsweb.EhCodContainer ? 11 : 50
    )

    limparDadosContainersDocumentos = () => {
        this.novaOsweb.ContainerSelecionado = ""
        this.novaOsweb.DocumentoSelecionado = ""

        this.mensagemContainerOuDocumento = "";
        this.valorContainer = null;
        this.valorDocumento = null;
        this.containers = [];
        this.documentos = [];
    }

    /**Armazenar os valores para enviar para salvar */
}



// WEBPACK FOOTER //
// ./src/modules/osweb/stores/OswebCadastrarStore.js